export enum CompetitorsColumns {
  CITY_STATE = 'cityState',
  DISTRICT = 'district',
  DOUBLES_WTN = 'scaling_wtn doubles',
  DRAG = 'drag',
  DRAW_STATUS = 'drawStatus',
  DRAWS = 'draws',
  INDEX = 'index',
  NAME = 'name',
  NTRP = 'scaling_ntrp',
  OPTIONS = 'options',
  PLAYERS = 'players',
  PT = 'scaling_pt',
  PT_ORANGE_PLAY = 'scaling_pt orange play',
  PT_GREEN_WIN = 'scaling_pt green win',
  PT_GREEN_PLAY = 'scaling_pt green play',
  RANK = 'scaling_ranking',
  SECTION = 'section',
  SELECTION = 'selection',
  SEED = 'seed',
  SINGLES_WTN = 'scaling_wtn singles',
  PLAYER_STATUS = 'player_status',
}
